import * as React from 'react';
import {connect} from 'react-redux';

import get from 'lodash/get';
import set from 'lodash/set';
import unset from 'lodash/unset';

import {Assignables} from 'nutshell-core/assignables';
import {Routing} from 'nutshell-core/routing';
import * as Schema from 'nutshell-core/schema';
import {Session} from 'nutshell-core/session';
import type {User, UnserializedFilterObject} from 'nutshell-core/types';

import {CheckboxButton} from 'shells/button/checkbox-button/checkbox-button';
import {convertToModels} from 'shells/filter-capsule/convert-to-models';
import {FilterCapsule} from 'shells/filter-capsule/filter-capsule';

import type {NutshellState} from '../../../../store';

// @ts-expect-error
import * as actions from '../../dashboard-actions';
// @ts-expect-error
import * as dashboardSelectors from '../../dashboard-selectors';

import styles from './todo-filters.module.css';

type OwnProps = {
    filter: string;
    hasSteps: boolean;
    hasAssigneeFilter: boolean;
};

type StateProps = {
    schema: Schema.Properties;
    currentUserName: string | null | undefined;
    users: User[];
};

type DispatchProps = {
    onFilterUpdate: (newFilter: string) => void;
};

type Props = OwnProps & StateProps & DispatchProps;

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        schema: dashboardSelectors.getDashboardSchema(state),
        currentUserName: Session.getSessionStateUserName(state),
        // @ts-expect-error
        users: Assignables.getAllEnabledUsers(state),
    };
};

// @ts-expect-error
const mapDispatchToProps = (dispatch): DispatchProps => {
    return {
        onFilterUpdate: (formValues) => {
            actions.updateTodoFilterForm(formValues, dispatch);
        },
    };
};

export class TodoFiltersComponent extends React.Component<Props> {
    render() {
        const formValues = Routing.deparam(this.props.filter);
        const isOnlyDueChecked = get(formValues, 'onlyDue') === 'true';
        const isOnlyHotLeadsChecked = get(formValues, 'onlyHotLeads') === 'true';
        const typeField = this.getTypeSchemafield();

        return (
            <div className={styles.container}>
                {typeField ? (
                    <FilterCapsule
                        // @ts-expect-error
                        collection={convertToModels(typeField.enum)}
                        filter={get(formValues, 'type')}
                        filterName='type'
                        schemaField={typeField}
                        onSubmit={this.handleFilterSubmit}
                        // @ts-expect-error
                        onUpdate={this.handleFilterSubmit}
                        onRemove={this.handleFormFilterRemove}
                    />
                ) : null}
                {this.props.hasAssigneeFilter ? (
                    <FilterCapsule
                        collection={convertToModels(this.props.users)}
                        filter={get(formValues, 'assignee')}
                        filterName='assignee'
                        defaultValueTitle={`Assignee: ${this.props.currentUserName || '…'}`}
                        schemaField={this.props.schema.todoAssignee}
                        onSubmit={this.handleFilterSubmit}
                        // @ts-expect-error
                        onUpdate={this.handleFilterSubmit}
                        onRemove={this.handleFormFilterRemove}
                    />
                ) : undefined}
                {this.props.hasSteps && !NutClientConfig.hasSalesProcessSetupOverhaulNUT7581 ? (
                    <CheckboxButton
                        label='Only steps with due times'
                        checked={isOnlyDueChecked}
                        size='small'
                        onChange={(data) => this.handleFormFilterChange('onlyDue', data)}
                    />
                ) : undefined}
                {NutClientConfig.hasHotLeads ? (
                    <CheckboxButton
                        label='Only hot leads'
                        checked={isOnlyHotLeadsChecked}
                        size='small'
                        onChange={(isChecked) =>
                            this.handleFormFilterChange('onlyHotLeads', isChecked)
                        }
                    />
                ) : undefined}
            </div>
        );
    }

    // in the case of instances in the new SA world,
    // `Tasks` and `Steps` are being consolidated (on the back end)
    // so we want to hide `Steps` in the filter form
    getTypeSchemafield = (): Schema.EnumField | null | undefined => {
        // refinement for flow, and protect against incomplete/unloaded schema
        if (!this.props.schema.todoType || this.props.schema.todoType.type !== 'enum') return null;

        if (!NutClientConfig.hasSalesProcessSetupOverhaulNUT7581) return this.props.schema.todoType;

        return {
            ...this.props.schema.todoType,
            // @ts-expect-error
            enum: ['Tasks', 'Follow-up tasks'],
        };
    };

    handleFilterSubmit = (data: UnserializedFilterObject<any>, key: string) => {
        const filterName = Object.keys(data)[0];
        // @ts-expect-error
        this.handleFormFilterChange(key, data[filterName]);
    };

    handleFormFilterChange = (key: string, newValue: string | any | boolean) => {
        const value = this.props.filter;

        const deparamedCurrentValue = Routing.deparam(value);
        set(deparamedCurrentValue, key, newValue);
        const paramedNewValue = Routing.param(deparamedCurrentValue);

        this.props.onFilterUpdate(paramedNewValue);
    };

    handleFormFilterRemove = (key: string) => {
        const deparamedCurrentValue = Routing.deparam(this.props.filter);
        unset(deparamedCurrentValue, key);
        const paramedNewValue = Routing.param(deparamedCurrentValue);

        this.props.onFilterUpdate(paramedNewValue);
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const TodoFilters = connector(TodoFiltersComponent);
